











import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiService } from '@/services/ApiService';
import { InventoriesApi } from '@eurogast/hub-client-typescript';
import { ConfigService } from '@/services/ConfigService';
import ConfirmationActionButton from '@/common/ConfirmationActionButton.vue';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component({
  components: {ConfirmationActionButton}
})
export default class InventoriesDeleteButton extends Vue {
  @Prop()
  public localInventoryId: string;
  @Prop()
  public localInventoryDate: string;
  @Prop()
  public localInventoryCount: number;

  get inventoryId(): number {
    return parseInt(this.localInventoryId, 0);
  }

  public deleteInventory() {
    MatomoEvents.forInventory.delete.publish();
    ApiService.wrap(InventoriesApi)
      .deleteInventory(ConfigService.getTenant(),
        this.inventoryId)
      .then(() => {
        const infoMessage = this.$tc('inventories.inventoriesDeleteButton.inventoryWithItemsHasBeenDeleted',
                this.localInventoryCount,
                { inventoryDate: this.localInventoryDate, totalItems: this.localInventoryCount }
                );
        localStorage.setItem('showMessage', 'true');
        localStorage.setItem('infoMessage', infoMessage);
        (this.$refs.confirmationActionButton as ConfirmationActionButton).hideDialog();
      })
      .then(() => window.location.href = '/my/inventories')
      .catch(ApiService.defaultErrorHandler);
  }
}
